import { getValue } from "@utils/lodash";
import * as React from "react";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import NoAccessPage from "@components/common/NoAccess";
import Loader from "@components/common/Loader";
import DashboardSvgComponent from "../../../assets/svg-components/left-menu/dashboard";
import { Line, Bar, Doughnut } from "react-chartjs-2";
import { ResponsivePie } from "@stu-dev/nivo-pie";
import {
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import qs from "query-string";

import "./index.scss";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  BarElement,
  Legend,
  ArcElement,
} from "chart.js";
import { AnyObject } from "chart.js/types/basic";
import RightMenuHeaders from "@components/common/RightMenuHeaders";
import { useEffect, useState } from "react";
import {
  countKeysWithValues,
  formatLabelValue,
  snakeToCamelWithSpaces,
} from "@_common/text-helpers";
import {
  NewDate,
  convertCurrentDate,
  convertCurrentDateWithTime,
  convertDate,
} from "@_common/date-helpers";
import { QueryRequestHelper } from "@_common/query-request-helper";
import { toast } from "react-toastify";
import DashboardUserFilterForm from "@components/common/DashboardFilterForm/user-filter-form";
import {
  getEntityGroups,
  getUserEntityGroupsItems,
} from "@services/entity-mapping.service";
import DashboardVCFilterForm from "@components/common/DashboardVCFilterForm";
import ManageAuditFilterForm from "@components/common/ManageAuditFilterForm";
import { formatText } from "@_common/format-text";
import { downloadRetrificationReport, getManageAuditScoreFilter, vendorAuditOverview } from "@services/audit.service";
import moment from "moment";
import SearchableDropdownSelect from "@_common/SearchableDropdown";
import {
  getVendorDashboardClient,
  getVendorDashboardClientReleaseCycle,
  getVendorDashboardClientReleaseDate,
  getVendorDashboardClientReleaseDateCycleDetails,
  refreshVendorComplaince,
} from "@services/dashboard.service";
import CheckpointMasterNotfound from "@components/Page-Not-Found/checkpoint-master-not-found";
import VCMasterNotfound from "@components/Page-Not-Found/vendorcompliance-master-not-found";
import { Modal, ModalBody } from "reactstrap";
import Notfound from "@components/Not-Found";
import ScrollableDataTable from "@components/ScrollableDatatable/index";
import FooterWrapper from "@components/common/FooterWrapper";
import RefreshSvgComponent from "../../../assets/svg-components/refresh";
import ReactTooltip from "react-tooltip";
import { cleanPayload } from "@pages/ManageAudit/AuditStatus/Constant/Util";
import { useParams } from "react-router-dom";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler
);

// Register required components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

interface ChartData {
  labels: string[];
  datasets: {
    label: string;
    data: number[]; // Ensure this is typed as an array of numbers
    fill: boolean;
    backgroundColor: string;
    borderColor: string;
    tension: number;
  }[];
}

type DonutDataItem = {
  id: string;
  label: string;
  value: number; // Assuming value is a number
  color: string;
};

type NumberDonutDataItem = {
  id: string;
  label: string;
  value: number; // Assuming value is a number
  color: string;
};

export default function VendorCompliance(props: any) {
  const navigate = useNavigate();
  const { id } = useParams();
  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */
  const [isLoading, setIsLoading] = React.useState(true);
  const [donutData, setDonutData] = useState<DonutDataItem[]>([]);
  const [numberDonutData, setNumberDonutData] = useState<NumberDonutDataItem[]>(
    []
  );
  const [noData, setNoData] = useState(false);
  const [releaseDateCycleData, setReleaseDateCycleData] = useState<any>([]);
  const [releaseDateCycleDataList, setreleaseDateCycleDataList] =
    React.useState<[]>([]);

  const colorsNew: { [key: string]: string } = {
    complied: "#05a357",
    non_complied: "#EC7063",
    assigned: "#D0D3D4",
    posing: "#fd9933",
    delayed: "#D4AC0D",
    delay_reported: "#85C1E9",
    re_opened: "#FADBD8",
    event_not_occured: "#BF94BC",
    awaiting_approval: "#4B6C81",
    reported_non_complied: "#c25071",
  };

  const colorsChartNew = [
    "#05a357",
    "#EC7063",
    "#D0D3D4",
    "#fd9933",
    "#D4AC0D",
    "#85C1E9",
    "#FADBD8",
    "#BF94BC",
    "#4B6C81",
    "#c25071",
  ];

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top" as const, // Use a string literal type for the position
      },
      title: {
        display: true,
        text: "Last 12 months score",
      },
    },
    scales: {
      y: {
        beginAtZero: true, // Start the y-axis at 0
        grid: {
          display: false, // Remove gridlines on the y-axis
        },
      },
      x: {
        grid: {
          display: false, // Remove gridlines on the x-axis
        },
      },
    },
  };
  const optionsBarChart = {
    responsive: true,
    plugins: {
      legend: {
        position: "top" as const, // Use a string literal type for the position
      },
      title: {
        display: true,
        text: "Criticality status for non complied tasks", // Title of the chart
      },
    },
    scales: {
      y: {
        beginAtZero: true, // Start the y-axis at 0
        grid: {
          display: false, // Remove gridlines on the y-axis
        },
      },
      x: {
        grid: {
          display: false, // Remove gridlines on the x-axis
        },
      },
    },
  };

  const optionsBarChartNC = {
    responsive: true,
    plugins: {
      legend: {
        position: "top" as const, // Use a string literal type for the position
      },
      title: {
        display: true,
        text: "Non Complied Contribution by Category", // Title of the chart
      },
    },
    scales: {
      y: {
        beginAtZero: true, // Start the y-axis at 0
        grid: {
          display: false, // Remove gridlines on the y-axis
        },
      },
      x: {
        grid: {
          display: false, // Remove gridlines on the x-axis
        },
      },
    },
  };

  const optionsBarChartAC = {
    responsive: true,
    plugins: {
      legend: {
        position: "top" as const, // Use a string literal type for the position
      },
      title: {
        display: true,
        text: "Total Audit Status", // Title of the chart
      },
    },
    scales: {
      y: {
        beginAtZero: true, // Start the y-axis at 0
        grid: {
          display: false, // Remove gridlines on the y-axis
        },
      },
      x: {
        grid: {
          display: false, // Remove gridlines on the x-axis
        },
      },
    },
  };

  const dataDonutPercent = [
    {
      id: "Category A",
      label: "Category A",
      value: 25,
      color: "hsl(348, 70%, 50%)",
    },
    {
      id: "Category B",
      label: "Category B",
      value: 35,
      color: "hsl(196, 70%, 50%)",
    },
    {
      id: "Category C",
      label: "Category C",
      value: 15,
      color: "hsl(53, 70%, 50%)",
    },
    {
      id: "Category D",
      label: "Category D",
      value: 25,
      color: "hsl(164, 70%, 50%)",
    },
  ];

  const totalValue = dataDonutPercent.reduce(
    (acc, data) => acc + data.value,
    0
  );
  const dataDonutPercentWithPercentage = dataDonutPercent.map((data) => ({
    ...data,
    percentage: ((data.value / totalValue) * 100).toFixed(2), // Calculate percentage
  }));

  const [activeTab, setActiveTab] = React.useState<string>("1");

  const toggleTab = (tab: string) => {
    if (activeTab !== tab) setActiveTab(tab);
  };


  /* -------------------------------------------------------------------------- */
  /*                                UseState Section                            */
  /* -------------------------------------------------------------------------- */
  const [filterIsOpen, setFilterIsOpen] = useState(false);
  const [isFilterVisible, setFilterVisibility] = React.useState(false);
  const [date, setDate] = useState<Date | null>(null);

  const handleFilter = () => {
    setFilterIsOpen(!filterIsOpen);
  };

  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());

  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  // useEffect(() => {
  //   const urlSearchParams = new URLSearchParams(window.location.search);
  //   const params = Object.fromEntries(urlSearchParams.entries());
  //   if (Object.keys(params).length === 0 && props.permissionAPITriggered) {
  //     let dates = params.date ? new Date(params.date) : new Date();
  //     var from_date = new Date(dates.getFullYear(), dates.getMonth(), 1);
  //     var to_date = new Date(dates.getFullYear(), dates.getMonth() + 1, 0);
  //     setFirstDay(from_date);
  //     setLastDay(to_date);
  //   }
  // }, [props.permissionAPITriggered]);

  // useEffect(() => {
  //   const urlSearchParams = new URLSearchParams(window.location.search);
  //   const params = Object.fromEntries(urlSearchParams.entries());
  //   if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
  //     if (params.from_date && params.to_date) {
  //       // setDate(new Date(params.date));
  //       var from_date = new Date(params.from_date);
  //       var to_date = new Date(params.to_date);
  //       setFirstDay(from_date);
  //       setLastDay(to_date);
  //     } else {
  //       let dates = params.date ? new Date(params.date) : new Date();
  //       var from_date = new Date(dates.getFullYear(), dates.getMonth(), 1);
  //       var to_date = new Date(dates.getFullYear(), dates.getMonth() + 1, 0);
  //       setFirstDay(from_date);
  //       setLastDay(to_date);
  //     }
  //   }
  // }, [window.location.href, props.permissionAPITriggered]);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length === 0 && props.permissionAPITriggered) {
      getData();
      getReleaseDateData();
      getReleaseCycleData();
      setDate(new Date());
      getRegionsList("", "");
      getGroupsList("", "", "");
      getStatesList("", "", "", "");
      getCitiesList("", "", "", "", "");
      getLocationsList("","","","","","");
      getVendorList("","","","","","","");

      getReleaseCycleDetailsData("");
    }
  }, [props.permissionAPITriggered]);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
      getData();
      getReleaseDateData();
      getReleaseCycleData();
      getReleaseCycleDetailsData("");

      if (params.page_no) {
        setPage_no(parseInt(params.page_no));
      }
      // if (params.search_text) {
      //   setSearchInput(params.search_text);
      //   setShowSearchTextbox(true);
      // }
      if (params.limit) {
        setLimit(parseInt(params.limit));
      }
      if (params.date) {
        setDate(new Date(params.date));
      } else {
        setDate(new Date());
      }

      //-----------------region & group-----------------//
      // if (getValue(params, `region_id`, "")) {
      //   getRegionsList("", getValue(params, `region_id`, ""));
      //   getGroupsList(
      //     "",
      //     getValue(params, `region_id`, ""),
      //     getValue(params, `group_id`, "")
      //   );
      // } else {
      //   getRegionsList("", getValue(params, `region_id`, ""));
      // }

      // //-----------------location-----------------//
      // if (getValue(params, `group_id`, "")) {
      //   getLocationsList(
      //     "",
      //     getValue(params, `region_id`, ""),
      //     getValue(params, `group_id`, ""),
      //     // getValue(params, `state_id`, ""),
      //     // getValue(params, `city_id`, ""),
      //     getValue(params, `location_id`, "")
      //   );
      // }
      // //-----------------vendor-----------------//
      // if (getValue(params, `location_id`, "")) {
      //   getVendorList(
      //     "",
      //     getValue(params, `region_id`, ""),
      //     getValue(params, `group_id`, ""),
      //     // getValue(request, `state_id`, ""),
      //     // getValue(request, `city_id`, ""),
      //     getValue(params, `location_id`, ""),
      //     getValue(params, `vendor_id`, "")
      //   );
      // }

      //-----------------region & group-----------------//
      if (getValue(params, `region_id`, "")) {
        getRegionsList("", getValue(params, `region_id`, ""));
        getGroupsList(
          "",
          getValue(params, `region_id`, ""),
          getValue(params, `group_id`, "")
        );
      } else {
        getRegionsList("", getValue(params, `region_id`, ""));
      }

      //-----------------state-----------------//

      if (getValue(params, `group_id`, "")) {
        getStatesList(
          "",
          getValue(params, `region_id`, ""),
          getValue(params, `group_id`, ""),
          getValue(params, `state_id`, "")
        );
      }

      //-----------------city-----------------//

      if (getValue(params, `state_id`, "")) {
        getCitiesList(
          "",
          getValue(params, `region_id`, ""),
          getValue(params, `group_id`, ""),
          getValue(params, `state_id`, ""),
          getValue(params, `city_id`, "")
        );
      }

      //-----------------location-----------------//
      if (getValue(params, `group_id`, "")) {
        getLocationsList(
          "",
          getValue(params, `region_id`, ""),
          getValue(params, `group_id`, ""),
          getValue(params, `state_id`, ""),
          getValue(params, `city_id`, ""),
          getValue(params, `location_id`, "")
        );
      }
      //-----------------vendor-----------------//
      if (getValue(params, `location_id`, "")) {
        getVendorList(
          "",
          getValue(params, `region_id`, ""),
          getValue(params, `group_id`, ""),
          getValue(request, `state_id`, ""),
          getValue(request, `city_id`, ""),
          getValue(params, `location_id`, ""),
          getValue(params, `vendor_id`, "")
        );
      }


      setRequest({
        ...request,
        region_id: getValue(params, `region_id`, ""),
        group_id: getValue(params, `group_id`, ""),
        state_id: getValue(params, `state_id`, ""),
        city_id: getValue(params, `city_id`, ""),
        location_id: getValue(params, `location_id`, ""),
        vendor_id: getValue(params, `vendor_id`, ""),
        // audit_type: getValue(params, `audit_type`, ""),
      });
      if (getValue(params, `region_id`, "")) {
        setFilterVisibility(true);
      }
    }
  }, [window.location.href, props.permissionAPITriggered]);

  const [refreshLoading, setRefreshLoading] = useState(false);

  const handleRefresh = async () => {
 try {


   await Promise.all([
      refreshVendorComplaince(),
      getData(),
      getReleaseDateData(),
      getReleaseCycleData(),
      getReleaseCycleDetailsData("")
   ]);

 } catch (error) {
   console.log(error);
 }
};

  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */

  // const getData = async () => {
  //   const urlSearchParams = new URLSearchParams(window.location.search);
  //   const params = Object.fromEntries(urlSearchParams.entries());
  //   let dates = date ? date : new Date();
  //   let payload: any = {
  //     month: params.date
  //       ? params.date.split("-")[1]
  //       : date
  //       ? moment(date).format("MM")
  //       : moment(dates).format("MM"),
  //     year: params.date
  //       ? params.date.split("-")[0]
  //       : date
  //       ? moment(date).format("YYYY")
  //       : moment(dates).format("YYYY"),
  //     page_no: params.page_no ? parseInt(params.page_no) : 1,
  //     page_size: params.limit ? parseInt(params.limit) : limit,
  //     search_text: params.search_text,
  //     sort_by: params.sort_by,
  //     region_id: params.region_id,
  //     group_id: params.group_id,
  //     location_id: params.location_id,
  //     vendor_id: params.vendor_id,
  //     // type: params.type ? params.type : "",
  //     // audit_type: params.audit_type,
  //     // state_id: getValue(params, `state_id`, ""),
  //     // city_id: getValue(params, `city_id`, ""),
  //   };
  //   let queryRequest = QueryRequestHelper(payload);
  //   try {
  //     setIsLoading(true);
  //     let resp = await getVendorDashboardClient(queryRequest);
  //     setIsLoading(false);
  //     if (resp) {
  //       console.log(resp, "---RESP---");
  //       const apiData = getValue(resp, `data[${0}]`, []);
  //       console.log(apiData, "APII");
  //       const updatedScores = [
  //         getValue(apiData, `prev_month_1_score`, 0),
  //         getValue(apiData, `prev_month_2_score`, 0),
  //         getValue(apiData, `prev_month_3_score`, 0),
  //         getValue(apiData, `prev_month_4_score`, 0),
  //         getValue(apiData, `prev_month_5_score`, 0),
  //         getValue(apiData, `prev_month_6_score`, 0),
  //         getValue(apiData, `prev_month_7_score`, 0),
  //         getValue(apiData, `prev_month_8_score`, 0),
  //         getValue(apiData, `prev_month_9_score`, 0),
  //         getValue(apiData, `prev_month_10_score`, 0),
  //         getValue(apiData, `prev_month_11_score`, 0),
  //         getValue(apiData, `prev_month_12_score`, 0),
  //       ].map(score => score !== null ? parseFloat(score) : 0); // Default to 0 if score is null

  //       // Line chart data
  //       setChartData(prevData => ({
  //         ...prevData,
  //         datasets: [
  //           {
  //             ...prevData.datasets[0],
  //             data: updatedScores, // Replace the dataset with new scores
  //           },
  //         ],
  //       }));

  //       setDataBarChart({
  //         labels: ["Non Complied"], // Label for the bar group
  //         datasets: [
  //           {
  //             label: "Critical", // First bar
  //             data: [getValue(apiData, 'critical_count', 0)], // Value from the 'critical_count' field
  //             backgroundColor: "rgba(255, 99, 132, 0.5)", // Bar color for 'Critical'
  //             borderColor: "rgba(255, 99, 132, 1)",
  //             borderWidth: 1,
  //             barThickness: 80, // Adjust thickness here
  //             maxBarThickness: 60, // You can also adjust this here
  //           },
  //           {
  //             label: "Non-Critical", // Second bar
  //             data: [getValue(apiData, 'non_critical_count', 0)], // Value from the 'non_critical_count' field
  //             backgroundColor: "rgba(54, 162, 235, 0.5)", // Bar color for 'Non-Critical'
  //             borderColor: "rgba(54, 162, 235, 1)",
  //             borderWidth: 1,
  //             barThickness: 80, // Adjust thickness here
  //             maxBarThickness: 60, // You can also adjust this here
  //           },
  //         ],
  //       });
  //       setIsLoading(false);
  //     } else {
  //       setIsLoading(false);
  //     }
  //   } catch (error) {
  //     setIsLoading(false);
  //   }
  // };

  const getData = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    let selectedMonth = params.date
      ? params.date.split("-")[1]
      : date
      ? moment(date).format("MM")
      : moment(dates).format("MM");
    let selectedYear = params.date
      ? params.date.split("-")[0]
      : date
      ? moment(date).format("YYYY")
      : moment(dates).format("YYYY");

    let payload: any = {
      month: selectedMonth,
      year: selectedYear,
      // page_no: params.page_no ? parseInt(params.page_no) : 1,
      // page_size: params.limit ? parseInt(params.limit) : limit,
      search_text: params.search_text,
      sort_by: params.sort_by,
      region_id: params.region_id,
      group_id: params.group_id,
      location_id: params.location_id,
      vendor_id: params.vendor_id,
      state_id: params.state_id,
      city_id: params.city_id,
    };

    let queryRequest = QueryRequestHelper(payload);

    try {
      setIsLoading(true);
      let resp = await getVendorDashboardClient(queryRequest);
      setIsLoading(false);

      if (getValue(resp, `data`, []).length === 0) {
        throw "Error";
      }

      if (resp) {
        const apiData = getValue(resp, `data[${0}]`, []);

        // Get the current month score (October 2024)
        // const currentMonthScore = getValue(apiData, "score", 0);

        // // Calculate the previous months and labels based on the selected month and year
        // const months = [];
        // const labels: string[] = [];
        // let month = parseInt(selectedMonth);
        // let year = parseInt(selectedYear);

        // for (let i = 0; i <= 11; i++) {
        //   // Push the current month and year in "MMM YYYY" format
        //   labels.push(moment(`${year}-${month}-01`).format("MMM YYYY"));

        //   // Calculate the previous month and adjust the year if necessary
        //   month -= 1;
        //   if (month === 0) {
        //     month = 12;
        //     year -= 1;
        //   }
        //   months.push({ month, year });
        // }

        // // Get previous scores from the response and map them
        // const updatedScores = [
        //   currentMonthScore, // Current month score (October 2024)
        //   getValue(apiData, `prev_month_1_score`, 0),
        //   getValue(apiData, `prev_month_2_score`, 0),
        //   getValue(apiData, `prev_month_3_score`, 0),
        //   getValue(apiData, `prev_month_4_score`, 0),
        //   getValue(apiData, `prev_month_5_score`, 0),
        //   getValue(apiData, `prev_month_6_score`, 0),
        //   getValue(apiData, `prev_month_7_score`, 0),
        //   getValue(apiData, `prev_month_8_score`, 0),
        //   getValue(apiData, `prev_month_9_score`, 0),
        //   getValue(apiData, `prev_month_10_score`, 0),
        //   getValue(apiData, `prev_month_11_score`, 0),
        //   getValue(apiData, `prev_month_12_score`, 0),
        // ].map((score) => (score !== null ? parseFloat(score) : 0)); // Default to 0 if score is null

        // // Line chart data
        // setChartData((prevData) => ({
        //   ...prevData,
        //   labels: labels, // Dynamically generated labels for months
        //   datasets: [
        //     {
        //       ...prevData.datasets[0],
        //       data: updatedScores, // Replace the dataset with new scores
        //     },
        //   ],
        // }));

        const currentMonthScore = getValue(apiData, "score", 0) ?? 0;

        // Log the current month score

        // Generate labels and months array for the past 13 months, including the current month
        const months = [];
        const labels: string[] = [];
        let month = parseInt(selectedMonth);
        let year = parseInt(selectedYear);

        // Add the current month first
        labels.push(moment(`${year}-${month}-01`).format("MMM YYYY")); // Add current month label

        // Loop to add previous months
        for (let i = 0; i < 12; i++) {
          // Loop for 12 previous months
          month -= 1;
          if (month === 0) {
            month = 12;
            year -= 1;
          }
          labels.push(moment(`${year}-${month}-01`).format("MMM YYYY"));
          months.push({ month, year });
        }

        // Get previous scores from the response and map them
        const previousScores = [
          getValue(apiData, `prev_month_12_score`, 0),
          getValue(apiData, `prev_month_11_score`, 0),
          getValue(apiData, `prev_month_10_score`, 0),
          getValue(apiData, `prev_month_9_score`, 0),
          getValue(apiData, `prev_month_8_score`, 0),
          getValue(apiData, `prev_month_7_score`, 0),
          getValue(apiData, `prev_month_6_score`, 0),
          getValue(apiData, `prev_month_5_score`, 0),
          getValue(apiData, `prev_month_4_score`, 0),
          getValue(apiData, `prev_month_3_score`, 0),
          getValue(apiData, `prev_month_2_score`, 0),
          getValue(apiData, `prev_month_1_score`, 0),
        ].map((score) => (score !== null ? parseFloat(score) : 0)); // Default to 0 if score is null

        // Combine previous scores with the current month score
        const updatedScores = [...previousScores, currentMonthScore]; // Move current score to the end

        // Log the updated scores to see the values being plotted

        // The labels array is already in the correct order
        // Line chart data: updating the chart with labels and scores
        setChartData((prevData) => ({
          ...prevData,
          labels: labels.reverse(), // Labels should be reversed to show from past to present
          datasets: [
            {
              ...prevData.datasets[0],
              data: updatedScores, // The order is now correct: previous scores followed by the current score
            },
          ],
        }));

        // setDataBarChart({
        //   labels: ["Non Complied"], // Label for the bar group
        //   datasets: [
        //     {
        //       label: "Critical", // First bar
        //       data: [getValue(apiData, 'critical_count', 0)], // Value from the 'critical_count' field
        //       backgroundColor: "rgba(255, 99, 132, 0.5)", // Bar color for 'Critical'
        //       borderColor: "rgba(255, 99, 132, 1)",
        //       borderWidth: 1,
        //       barThickness: 80, // Adjust thickness here
        //       maxBarThickness: 60, // You can also adjust this here
        //     },
        //     {
        //       label: "Non-Critical", // Second bar
        //       data: [getValue(apiData, 'non_critical_count', 0)], // Value from the 'non_critical_count' field
        //       backgroundColor: "rgba(54, 162, 235, 0.5)", // Bar color for 'Non-Critical'
        //       borderColor: "rgba(54, 162, 235, 1)",
        //       borderWidth: 1,
        //       barThickness: 80, // Adjust thickness here
        //       maxBarThickness: 60, // You can also adjust this here
        //     },
        //   ],
        // });

        // Dynamically generate the labels and datasets for the bar chart
        const event = getValue(apiData, "event", {});
        const eventKeys = Object.keys(event); // Get keys like 'critical_count', 'non_critical_count'

        // Dynamically create datasets from event data
        const datasets = eventKeys.map((key, index) => {
          const modifiedKey = key.replace(/_count$/, "");
          return {
            label: snakeToCamelWithSpaces(modifiedKey), // Use the modified key for the label
            data: [getValue(event, key, 0)], // Get the value of the original event type
            backgroundColor: `rgba(${255 - index * 50}, ${
              99 + index * 50
            }, 132, 0.5)`, // Dynamic color for each bar
            borderColor: `rgba(${255 - index * 50}, ${
              99 + index * 50
            }, 132, 1)`,
            borderWidth: 1,
            barThickness: 80,
            maxBarThickness: 60,
          };
        });

        // Update bar chart with dynamic datasets
        setDataBarChart({
          labels: ["Non Complied"], // You can adjust this to fit your needs
          datasets: datasets,
        });

        //Percentage Donut Chart
        const dataNew = getValue(apiData, "audit_status_percentages", {});
        const total: number = Object.values(dataNew).reduce(
          (acc: number, val: any) => acc + (typeof val === "number" ? val : 0),
          0
        );

        const transformedData: DonutDataItem[] = Object.entries(dataNew).map(
          ([id, value], index) => {
            return {
              id: snakeToCamelWithSpaces(id),
              label: snakeToCamelWithSpaces(id),
              value:
                typeof value === "number"
                  ? parseFloat(((value / total) * 100).toFixed(2))
                  : 0,
              color: colorsNew[id],
            };
          }
        );

        const formattedTransformedData: DonutDataItem[] = transformedData.map(
          (item) => ({
            ...item,
            value: parseFloat(item.value.toFixed(2)),
            displayValue: item.value.toFixed(2) + "%",
          })
        );
        setDonutData(formattedTransformedData);

        //Count Pie Graph
        const dataNewNumber = getValue(apiData, "audit_status_counts", {});
        const totalNumber: number = Object.values(dataNewNumber).reduce(
          (acc: number, val: any) => acc + (typeof val === "number" ? val : 0),
          0
        );
        const transformedDataNumber: NumberDonutDataItem[] = Object.entries(
          dataNewNumber
        ).map(([id, value], index) => ({
          id: snakeToCamelWithSpaces(id),
          label: snakeToCamelWithSpaces(id),
          value: typeof value === "number" ? value : 0,
          color: colorsNew[id],
        }));

        const formattedTransformedDataNumber: NumberDonutDataItem[] =
          transformedDataNumber.map((item) => ({
            ...item,
            value: parseFloat(item.value.toFixed(2)),
            displayValue: item.value.toFixed(2),
          }));
        setNumberDonutData(formattedTransformedDataNumber);

        //Category Bar Chart
        // const category = getValue(apiData, 'category_of_law', {});
        // const categoryKeys = Object.keys(category); // Get keys like 'critical_count', 'non_critical_count'

        // const datasetsCategory = categoryKeys.map((key, index) => {
        //   const modifiedKey = key.replace(/_count$/, "");
        //     // Set dynamic color in shades of orange
        //     const redValue = 255; // Full red for orange
        //     const greenValue = 165 + index * 10; // Increase green slightly for each bar
        //     const blueValue = 0; // No blue for pure orange

        //   return {
        //     label: snakeToCamelWithSpaces(modifiedKey), // Use the modified key for the label
        //     data: [getValue(category, key, 0)], // Get the value of the original event type
        //     backgroundColor: `rgba(${redValue}, ${greenValue}, ${blueValue}, 0.5)`, // Dynamic orange color
        //     borderColor: `rgba(${redValue}, ${greenValue}, ${blueValue}, 1)`,
        //               borderWidth: 1,
        //     barThickness: 80,
        //     maxBarThickness: 60,
        //   };
        // });
        // // Update bar chart with dynamic datasets
        // setDataBarChartNC({
        //   labels: ["Contribution"], // You can adjust this to fit your needs
        //   datasets: datasetsCategory,
        // });

        const category = getValue(apiData, "category_of_law", {});
        const categoryKeys = Object.keys(category); // Get keys like 'critical_count', 'non_critical_count'

        // Utility function to convert snake_case to camelCase with spaces, and remove "category" and "count"
        const cleanKeyLabel = (key: string) => {
          return key
            .replace(/_count$/, "") // Remove "_count"
            .replace(/category/i, "") // Remove "category"
            .replace(/_/g, " ") // Replace underscores with spaces
            .trim(); // Remove any trailing spaces
        };

        const predefinedHSLColors = [
          { hue: 34, saturation: 50, lightness: 55 }, // Muted orange
          { hue: 120, saturation: 75, lightness: 50 }, // Soft green
          { hue: 210, saturation: 65, lightness: 60 }, // Light blue
          { hue: 290, saturation: 60, lightness: 65 }, // Soft purple
          { hue: 50, saturation: 75, lightness: 70 }, // Light yellow
          { hue: 0, saturation: 70, lightness: 60 }, // Soft red
          { hue: 180, saturation: 65, lightness: 50 }, // Muted teal
          { hue: 260, saturation: 70, lightness: 55 }, // Muted violet
        ];

        // Helper function to generate color from predefined HSL array
        const generateConsistentColor = (index: any) => {
          const { hue, saturation, lightness } =
            predefinedHSLColors[index % predefinedHSLColors.length]; // Loop through colors if there are more keys than colors
          return {
            backgroundColor: `hsl(${hue}, ${saturation}%, ${lightness}%, 0.6)`, // 60% opacity for background
            borderColor: `hsl(${hue}, ${saturation}%, ${lightness}%, 1)`, // Full opacity for border
          };
        };

        const datasetsCategory = categoryKeys.map((key, index) => {
          const cleanedKey = cleanKeyLabel(key); // Clean the key for the label

          const colors = generateConsistentColor(index); // Get consistent color for each key

          return {
            label: snakeToCamelWithSpaces(cleanedKey), // Use the cleaned key for the label
            data: [getValue(category, key, 0)], // Get the value of the original event type
            backgroundColor: colors.backgroundColor, // Dynamic color
            borderColor: colors.borderColor,
            borderWidth: 1,
            barThickness: 80,
            maxBarThickness: 60,
          };
        });

        // Update bar chart with dynamic datasets
        setDataBarChartNC({
          labels: ["Contribution"], // You can adjust this to fit your needs
          datasets: datasetsCategory,
        });

        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
      setNoData(false);
    } catch (error) {
      setIsLoading(false);
      console.error("Error fetching data:", error);
      // if (error === "Location Not Mapped") {
      setNoData(true);
      // }
    }
  };

  const getReleaseDateData = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    let payload: any = {
      month: params.date
        ? params.date.split("-")[1]
        : date
        ? moment(date).format("MM")
        : moment(dates).format("MM"),
      year: params.date
        ? params.date.split("-")[0]
        : date
        ? moment(date).format("YYYY")
        : moment(dates).format("YYYY"),
      // page_no: params.page_no ? parseInt(params.page_no) : 1,
      // page_size: params.limit ? parseInt(params.limit) : limit,
      search_text: params.search_text,
      sort_by: params.sort_by,
      region_id: params.region_id,
      group_id: params.group_id,
      location_id: params.location_id,
      vendor_id: params.vendor_id,
      // type: params.type ? params.type : "",
      // audit_type: params.audit_type,
      state_id: getValue(params, `state_id`, ""),
      city_id: getValue(params, `city_id`, ""),
    };
    let queryRequest = QueryRequestHelper(payload);
    try {
      setIsLoading(true);
      let resp = await getVendorDashboardClientReleaseDate(queryRequest);
      setIsLoading(false);
      if (getValue(resp, `data`, []).length === 0) {
        throw "Error";
      }

      if (resp) {
        const apiData = getValue(resp, `data[${0}]`, []);
        const dynamicDataBarChart = {
          labels: ["Audit"], // Static label
          datasets: [
            {
              label: "Pending Sites", // Label for the first bar
              data: [parseInt(apiData.pending_audit)], // Use value from API response
              backgroundColor: "rgba(255, 99, 132, 0.5)", // Color for 'Pending Audit'
              borderColor: "rgba(255, 99, 132, 1)",
              borderWidth: 1,
              barThickness: 80,
              maxBarThickness: 60,
            },
            {
              label: "Completed Sites", // Label for the second bar
              data: [parseInt(apiData.audit_complete)], // Use value from API response
              backgroundColor: "rgba(54, 162, 235, 0.5)", // Color for 'Audit Completed'
              borderColor: "rgba(54, 162, 235, 1)",
              borderWidth: 1,
              barThickness: 80,
              maxBarThickness: 60,
            },
          ],
        };

        // Set the chart data with the dynamic values from API response
        setDataBarChartAC(dynamicDataBarChart);

        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      toast.dismiss();
      // if (error === "Location Not Mapped") {
      setNoData(true);
      // }
    }
  };

  const getReleaseCycleData = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    let payload: any = {
      month: params.date
        ? params.date.split("-")[1]
        : date
        ? moment(date).format("MM")
        : moment(dates).format("MM"),
      year: params.date
        ? params.date.split("-")[0]
        : date
        ? moment(date).format("YYYY")
        : moment(dates).format("YYYY"),
      // page_no: params.page_no ? parseInt(params.page_no) : 1,
      // page_size: params.limit ? parseInt(params.limit) : limit,
      search_text: params.search_text,
      sort_by: params.sort_by,
      region_id: params.region_id,
      group_id: params.group_id,
      location_id: params.location_id,
      vendor_id: params.vendor_id,
      state_id: getValue(params, `state_id`, ""),
      city_id: getValue(params, `city_id`, ""),
    };
    let queryRequest = QueryRequestHelper(payload);
    try {
      setIsLoading(true);
      let resp = await getVendorDashboardClientReleaseCycle(queryRequest);
      setIsLoading(false);
      if (resp) {
        setReleaseDateCycleData(getValue(resp, `data`, []));
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      toast.dismiss();
      // if (error === "Location Not Mapped") {
      setNoData(true);
      // }
    }
  };

  const getReleaseCycleDetailsData = async (type:any) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    const selectedType = type || params.type;

    let dates = date ? date : new Date();
    let payload: any = {
      month: params.date
        ? params.date.split("-")[1]
        : date
        ? moment(date).format("MM")
        : moment(dates).format("MM"),
      year: params.date
        ? params.date.split("-")[0]
        : date
        ? moment(date).format("YYYY")
        : moment(dates).format("YYYY"),
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      search_text: params.search_text,
      sort_by: params.sort_by,
      region_id: params.region_id,
      group_id: params.group_id,
      location_id: params.location_id,
      vendor_id: params.vendor_id,
      state_id: getValue(params, `state_id`, ""),
      city_id: getValue(params, `city_id`, ""),

    };
      // Add the conditional type logic
      if (selectedType === "partially_completed_location") {
        payload.partially_completed_location = true;
      } else if (selectedType === "fully_submitted_location") {
        payload.fully_submitted_location = true;
      } else if (selectedType === "not_submitted_location") {
        payload.not_submitted_location = true;
      }
    
    let queryRequest = QueryRequestHelper(payload);
    try {
      setIsLoading(true);
      let resp = await getVendorDashboardClientReleaseDateCycleDetails(
        queryRequest
      );
      setIsLoading(false);
      if (resp) {
        setreleaseDateCycleDataList(
          getValue(resp, `data.vendors_checkpoint`, []).map((item: object) => ({
            ...item,
            vendor_name: getValue(item, `vendor_name`, ""),
            site_name: getValue(item, `site_name`, ""),
            group_name: getValue(item, `group_name`, ""),
            head_count: getValue(item, `verified_headcount`, null) === null ? "-" : getValue(item, `verified_headcount`, "-"),
            score_count: getValue(item, `score`, null) === null ? "-" : `${getValue(item, `score`, 0)}%`,

          }))
        );
        setTotalCount(getValue(resp, `data.pagination.total`, 0));
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      toast.dismiss();
      // if (error === "Location Not Mapped") {
      setNoData(true);
      // }
    }
  };


  //Line Chart 12 months Record
  const [chartData, setChartData] = React.useState({
    labels: [
      "Jan 23",
      "Feb 23",
      "Mar 23",
      "Apr 23",
      "May 23",
      "Jun 23",
      "Jul 23",
      "Aug 23",
      "Sep 23",
      "Oct 23",
      "Nov 23",
      "Dec 23",
    ],
    datasets: [
      {
        label: "Score",
        data: Array(12).fill(0), // Set initial data to an array of zeros
        fill: true,
        backgroundColor: "rgba(75, 192, 192, 0.2)",
        borderColor: "rgba(75, 192, 192, 1)",
        tension: 0.4,
      },
    ],
  });

  //Bar Chart for Critical and Non Critical
  const [dataBarChart, setDataBarChart] = useState({
    labels: ["Non Complied"], // Label for the bar group
    datasets: [
      {
        label: "Critical", // First bar
        data: [0], // Default value
        backgroundColor: "rgba(255, 99, 132, 0.5)", // Bar color for 'Critical'
        borderColor: "rgba(255, 99, 132, 1)",
        borderWidth: 1,
        barThickness: 80, // Adjust thickness here
        maxBarThickness: 60, // You can also adjust this here
      },
      {
        label: "Non-Critical", // Second bar
        data: [0], // Default value
        backgroundColor: "rgba(54, 162, 235, 0.5)", // Bar color for 'Non-Critical'
        borderColor: "rgba(54, 162, 235, 1)",
        borderWidth: 1,
        barThickness: 80, // Adjust thickness here
        maxBarThickness: 60, // You can also adjust this here
      },
    ],
  });

  const [dataBarChartAC, setDataBarChartAC] = useState({
    labels: ["Audit"], // Label for the bar group
    datasets: [
      {
        label: "Pending Sites", // First bar
        data: [0], // Value for 'Critical'
        backgroundColor: "rgba(255, 99, 132, 0.5)", // Bar color for 'Critical'
        borderColor: "rgba(255, 99, 132, 1)",
        borderWidth: 1,
        barThickness: 80, // Adjust thickness here
        maxBarThickness: 60, // You can also adjust this here
      },
      {
        label: "Completed Sites", // Second bar
        data: [0], // Value for 'Non-Critical'
        backgroundColor: "rgba(54, 162, 235, 0.5)", // Bar color for 'Non-Critical'
        borderColor: "rgba(54, 162, 235, 1)",
        borderWidth: 1,
        barThickness: 80, // Adjust thickness here
        maxBarThickness: 60, // You can also adjust this here
      },
    ],
  });

  const [dataBarChartNC, setDataBarChartNC] = useState({
    labels: ["Contribution"], // Label for the bar group
    datasets: [
      {
        label: "Chalan", // First bar
        data: [0], // Value for 'Chalan'
        backgroundColor: "rgba(128, 128, 128, 0.7)", // Grey for 'Chalan'
        borderColor: "rgba(128, 128, 128, 1)",
        borderWidth: 1,
        barThickness: 80, // Adjust thickness here
        maxBarThickness: 60, // You can also adjust this here
      },
      {
        label: "Compliance", // Second bar
        data: [0], // Value for 'Compliance'
        backgroundColor: "rgba(255, 165, 0, 0.7)", // Orange for 'Compliance'
        borderColor: "rgba(255, 165, 0, 1)",
        borderWidth: 1,
        barThickness: 80, // Adjust thickness here
        maxBarThickness: 60, // You can also adjust this here
      },
      {
        label: "License", // Third bar
        data: [0], // Value for 'License'
        backgroundColor: "rgba(220, 20, 60, 0.7)", // Cherry Red for 'License'
        borderColor: "rgba(220, 20, 60, 1)",
        borderWidth: 1,
        barThickness: 80, // Adjust thickness here
        maxBarThickness: 60, // You can also adjust this here
      },
    ],
  });

  /* -------------------------------------------------------------------------- */
  /*                               Pagination section                           */
  /* -------------------------------------------------------------------------- */

  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(100);
  const [page_no, setPage_no] = useState(1);

  const handleChangePagination = (page_no: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload = {
      ...params,
      page_no: page_no,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    getReleaseCycleDetailsData("");
  };

  const handleChangeLimit = (limit: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      limit: limit,
      page_no: "1",
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    getReleaseCycleDetailsData("");
  };
  /* -------------------------------------------------------------------------- */
  /*                              Date Routes                                   */
  /* -------------------------------------------------------------------------- */
  // const [from_date, setFirstDay] = React.useState<any>(null);
  // const [to_date, setLastDay] = React.useState<any>(null);

  // const handleDate = (date: any) => {
  //   setFirstDay(date[0]);
  //   setLastDay(date[1]);
  // };
  // const handleSubmitDate = () => {
  //   const urlSearchParams = new URLSearchParams(window.location.search);
  //   const params = Object.fromEntries(urlSearchParams.entries());

  //   let first: any = from_date ? NewDate(from_date) : null;
  //   let last: any = to_date ? NewDate(to_date) : null;
  //   if (first && last && first !== "Invalid date" && last !== "Invalid date") {
  //     let payload: any = {
  //       ...params,
  //       from_date: convertDate(first),
  //       to_date: convertDate(last),
  //     };
  //     if (payload.from_date && payload.to_date) {
  //       let queryRequest = QueryRequestHelper(payload);
  //       navigate(`${window.location.pathname}?${queryRequest}`);
  //     } else {
  //       toast.error("Start Date and End Date Required");
  //     }
  //   } else {
  //     toast.error("Please select date");
  //   }
  // };

  const handleSubmitDate = () => {
    let dates = moment(date).format("YYYY-MM-DD");
    if (dates && dates !== "Invalid date") {
      let payload: any = {
        date: dates,
      };
      // removing null values
      Object.keys(payload).forEach((key) => {
        if (!payload[key] || payload[key] === undefined) {
          delete payload[key];
        }
      });
      let queryRequest = qs.stringify(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    } else {
      toast.error("Please select date");
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                        smart Filter section                                */
  /* -------------------------------------------------------------------------- */
  const [request, setRequest] = useState<any>({
    state_id: "",
    city_id: "",
    region_id: "",
    group_id: "",
    location_id: "",
    vendor_id: "",
  });
  const reset = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      page_no: params.page_no,
      search_text: getValue(params, `search_text`, ""),
      limit: getValue(params, `limit`, ""),
    };
    setRequest({
      ...request,
      state_id: "",
      city_id: "",
      region_id: "",
      group_id: "",
      location_id: "",
      vendor_id: "",
    });
    setGroupsList([]);
    setStateList([]);
    setCityList([]);
    setlocationsList([]);
    setvendorsList([]);
    //  setFilterVisibility(false);
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    getData();
    getReleaseDateData();
    getReleaseCycleData();
    getReleaseCycleDetailsData("");
    // getRegionsList("", getValue(params, `region_id`, ""));
    getRegionsList("", "");
    getGroupsList("", "", "");
    getStatesList("", "", "", "");
    getCitiesList("", "", "", "", "");
    getLocationsList("","","","","","");
    getVendorList("","","","","","","");
  };

  /* -------------------------------------------------------------------------- */
  /*                    smart Filter API section                                */
  /* -------------------------------------------------------------------------- */

  const [regionList, setRegionList] = useState([]);
  const [regionLoading, setRegionLoading] = useState(false);

  const getRegionsList = async (search_text: string, id: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    try {
      let payload = {
        month: params.date
          ? params.date.split("-")[1]
          : date
          ? moment(date).format("MM")
          : moment(dates).format("MM"),
        year: params.date
          ? params.date.split("-")[0]
          : date
          ? moment(date).format("YYYY")
          : moment(dates).format("YYYY"),
        type: "REGION",
        search_text: search_text,
        region_id: id,
        page_size:  100,
        is_redirect: true,
      };
      setRegionLoading(true);
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getManageAuditScoreFilter(queryRequest);

      if (getValue(resp, `data`, []).length === 0) {
        throw "Error";
      }

      if (resp) {
        setRegionList(
          getValue(resp, `data.vendors_checkpoint`, []).map((item: object) => ({
            ...item,
            id: getValue(item, `region_id`, ""),
            label: getValue(item, `region_name`, ""),
            value: getValue(item, `region_name`, ""),
          }))
        );
        setRegionLoading(false);
      } else {
        setRegionLoading(false);
      }
    } catch (error) {
      toast.dismiss();
      setRegionLoading(false);
      // if (error === "Location Not Mapped") {
      setNoData(true);
      // }
    }
  };

  const [groupsList, setGroupsList] = useState([]);
  const [groupLoading, setGroupLoading] = useState(false);
  const getGroupsList = async (
    search_text: string,
    region_id: string,
    id: string
  ) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    try {
      let payload = {
        month: params.date
          ? params.date.split("-")[1]
          : date
          ? moment(date).format("MM")
          : moment(dates).format("MM"),
        year: params.date
          ? params.date.split("-")[0]
          : date
          ? moment(date).format("YYYY")
          : moment(dates).format("YYYY"),
        region_id: region_id,
        type: "GROUP",
        search_text: search_text,
        group_id: id,
        page_size:  100,
        is_redirect: true,
      };
      setGroupLoading(true);
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getManageAuditScoreFilter(queryRequest);
      if (resp) {
        setGroupsList(
          getValue(resp, `data.vendors_checkpoint`, []).map((item: object) => ({
            ...item,
            id: getValue(item, `group_id`, ""),
            label: getValue(item, `group_name`, ""),
            value: getValue(item, `group_name`, ""),
          }))
        );
        setGroupLoading(false);
      } else {
        setGroupLoading(false);
      }
    } catch (error) {
      setGroupLoading(false);
    }
  };

  const [stateList, setStateList] = useState([]);
  const [stateLoading, setStateLoading] = useState(false);
  const getStatesList = async (
    search_text: string,
    region_id: string,
    group_id: string,
    id: string
  ) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    try {
      let payload = {
        month: params.date
          ? params.date.split("-")[1]
          : date
          ? moment(date).format("MM")
          : moment(dates).format("MM"),
        year: params.date
          ? params.date.split("-")[0]
          : date
          ? moment(date).format("YYYY")
          : moment(dates).format("YYYY"),
        region_id: region_id,
        group_id: group_id,
        type: "STATE",
        search_text: search_text,
        state_id: id,
        page_size:  100,
        is_redirect: true,
      };

      setStateLoading(true);
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getManageAuditScoreFilter(queryRequest);
      if (resp) {
        setStateList(
          getValue(resp, `data.vendors_checkpoint`, []).map((item: object) => ({
            ...item,
            id: getValue(item, `state_id`, ""),
            label: getValue(item, `state_name`, ""),
            value: getValue(item, `state_name`, ""),
          }))
        );
        setStateLoading(false);
      } else {
        setStateLoading(false);
      }
    } catch (error) {
      setStateLoading(false);
    }
  };

  const [cityList, setCityList] = useState([]);
  const [cityLoading, setCityLoading] = useState(false);
  const getCitiesList = async (
    search_text: string,
    region_id: string,
    group_id: string,
    state_id: string,
    id: string
  ) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    try {
      let payload = {
        month: params.date
          ? params.date.split("-")[1]
          : date
          ? moment(date).format("MM")
          : moment(dates).format("MM"),
        year: params.date
          ? params.date.split("-")[0]
          : date
          ? moment(date).format("YYYY")
          : moment(dates).format("YYYY"),
        region_id: region_id,
        group_id: group_id,
        type: "CITY",
        search_text: search_text,
        state_id: state_id,
        city_id: id,
        page_size:  100,
        is_redirect: true,
      };

      setCityLoading(true);
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getManageAuditScoreFilter(queryRequest);
      if (resp) {
        setCityList(
          getValue(resp, `data.vendors_checkpoint`, []).map((item: object) => ({
            ...item,
            id: getValue(item, `city_id`, ""),
            label: getValue(item, `city_name`, ""),
            value: getValue(item, `city_name`, ""),
          }))
        );
        setCityLoading(false);
      } else {
        setCityLoading(false);
      }
    } catch (error) {
      setCityLoading(false);
    }
  };

  const [locationsList, setlocationsList] = useState([]);
  const [locationLoading, setLocationLoading] = useState(false);
  const getLocationsList = async (
    search_text: string,
    region_id: string,
    group_id: string,
    state_id: string,
    city_id: string,
    id: string
  ) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    try {
      let payload = {
        month: params.date
          ? params.date.split("-")[1]
          : date
          ? moment(date).format("MM")
          : moment(dates).format("MM"),
        year: params.date
          ? params.date.split("-")[0]
          : date
          ? moment(date).format("YYYY")
          : moment(dates).format("YYYY"),
        region_id: region_id,
        group_id: group_id,
        type: "LOCATION",
        search_text: search_text,
        state_id: state_id,
        city_id: city_id,
        location_id: id,
        page_size:  100,
        is_redirect: true,
      };
      setLocationLoading(true);
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getManageAuditScoreFilter(queryRequest);
      if (resp) {
        setlocationsList(
          getValue(resp, `data.vendors_checkpoint`, []).map((item: object) => ({
            ...item,
            id: getValue(item, `location_id`, ""),
            label: getValue(item, `location_name`, ""),
            value: getValue(item, `location_name`, ""),
          }))
        );
        setLocationLoading(false);
      } else {
        setLocationLoading(false);
      }
    } catch (error) {
      setLocationLoading(false);
    }
  };

  const [vendorsList, setvendorsList] = useState([]);
  const [vendorLoading, setvendorLoading] = useState(false);
  const getVendorList = async (
    search_text: string,
    region_id: string,
    group_id: string,
    state_id: string,
    city_id: string,
    location_id: string,
    id: string
  ) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    try {
      let payload = {
        month: params.date
          ? params.date.split("-")[1]
          : date
          ? moment(date).format("MM")
          : moment(dates).format("MM"),
        year: params.date
          ? params.date.split("-")[0]
          : date
          ? moment(date).format("YYYY")
          : moment(dates).format("YYYY"),
        region_id: region_id,
        group_id: group_id,
        state_id: state_id,
        city_id: city_id,
        location_id: location_id,
        type: "VENDOR",
        search_text: search_text,
        vendor_id: id,
        page_size:  100,
        is_redirect: true,
      };
      setvendorLoading(true);
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getManageAuditScoreFilter(queryRequest);
      if (resp) {
        setvendorsList(
          getValue(resp, `data.vendors_checkpoint`, []).map((item: object) => ({
            ...item,
            id: getValue(item, `vendor_id`, ""),
            label: getValue(item, `vendor_name`, ""),
            value: getValue(item, `vendor_name`, ""),
          }))
        );
        setvendorLoading(false);
      } else {
        setvendorLoading(false);
      }
    } catch (error) {
      setvendorLoading(false);
    }
  };

  // const handleRemoveFilter = (name: string) => {
  //   if (name === "region_id") {
  //     setRequest({
  //       ...request,
  //       region_id: "",
  //       group_id: "",
  //       state_id: "",
  //       city_id: "",
  //       location_id: "",
  //       vendor_id: "",
  //       audit_type: "",
  //     });
  //     getRegionsList("", "");
  //     setGroupsList([]);
  //     setlocationsList([]);
  //     setvendorsList([]);
  //   }
  //   if (name === "group_id") {
  //     setRequest({
  //       ...request,
  //       group_id: "",
  //       location_id: "",
  //       vendor_id: "",
  //     });
  //     // getRegionsList("", "");
  //     getGroupsList("", getValue(request, `region_id`, ""), "");
  //     setlocationsList([]);
  //     setvendorsList([]);
  //   }

  //   if (name === "location_id") {
  //     setRequest({
  //       ...request,
  //       location_id: "",
  //       vendor_id: "",
  //     });

  //     getLocationsList(
  //       "",
  //       getValue(request, `region_id`, ""),
  //       getValue(request, `group_id`, ""),
  //       // getValue(request, `state_id`, ""),
  //       // getValue(request, `city_id`, ""),
  //       ""
  //     );
  //     setvendorsList([]);
  //   }
  //   if (name === "vendor_id") {
  //     setRequest({
  //       ...request,
  //       vendor_id: "",
  //       audit_type: "",
  //     });

  //     getVendorList(
  //       "",
  //       getValue(request, `region_id`, ""),
  //       getValue(request, `group_id`, ""),
  //       // getValue(request, `state_id`, ""),
  //       // getValue(request, `city_id`, ""),
  //       getValue(request, `location_id`, ""),
  //       ""
  //     );
  //   }
  // };

  // const handleSelectFilter = (id: any, name: string) => {
  //   if (name === "region_id") {
  //     getGroupsList("", id, "");
  //     setRequest({
  //       ...request,
  //       group_id: "",
  //       location_id: "",
  //       vendor_id: "",
  //     });
  //     setGroupsList([]);
  //     setlocationsList([]);
  //     setvendorsList([]);
  //   }
  //   if (name === "group_id") {
  //     getLocationsList(
  //       "",
  //       getValue(request, `region_id`, ""),
  //       id,
  //       // getValue(request, `group_id`, ""),
  //       // getValue(request, `state_id`, ""),
  //       // id,
  //       ""
  //     );
  //     setRequest({
  //       ...request,
  //       location_id: "",
  //       vendor_id: "",
  //     });
  //     setlocationsList([]);
  //     setvendorsList([]);
  //   }

  //   if (name === "location_id") {
  //     getVendorList(
  //       "",
  //       getValue(request, `region_id`, ""),
  //       getValue(request, `group_id`, ""),
  //       // getValue(request, `state_id`, ""),
  //       // getValue(request, `city_id`, ""),
  //       id,
  //       ""
  //     );
  //     setRequest({
  //       ...request,
  //       vendor_id: "",
  //     });
  //     setvendorsList([]);
  //   }

  //   setRequest({
  //     ...request,
  //     [name]: id,
  //   });
  // };

  const handleRemoveFilter = (name: string) => {
    if (name === "region_id") {
      setRequest({
        ...request,
        region_id: "",
        group_id: "",
        state_id: "",
        city_id: "",
        location_id: "",
        vendor_id: "",
        audit_type: "",
      });
      getRegionsList("", "");
      setGroupsList([]);
      setStateList([]);
      setCityList([]);
      setlocationsList([]);
      setvendorsList([]);
    }
    if (name === "group_id") {
      setRequest({
        ...request,
        group_id: "",
        state_id: "",
        city_id: "",
        location_id: "",
        vendor_id: "",
        audit_type: "",
      });
      // getRegionsList("", "");
      getGroupsList("", getValue(request, `region_id`, ""), "");
      setStateList([]);
      setCityList([]);
      setlocationsList([]);
      setvendorsList([]);
    }

    if (name === "state_id") {
      setRequest({
        ...request,
        state_id: "",
        city_id: "",
        location_id: "",
        vendor_id: "",
        audit_type: "",
      });
      // getRegionsList("", "");
      getStatesList(
        "",
        getValue(request, `region_id`, ""),
        getValue(request, `group_id`, ""),
        ""
      );
      setCityList([]);
      setlocationsList([]);
      setvendorsList([]);
    }

    if (name === "city_id") {
      setRequest({
        ...request,
        city_id: "",
        location_id: "",
        vendor_id: "",
        audit_type: "",
      });
      // getRegionsList("", "");
      getCitiesList(
        "",
        getValue(request, `region_id`, ""),
        getValue(request, `group_id`, ""),
        getValue(request, `state_id`, ""),
        ""
      );
      setlocationsList([]);
      setvendorsList([]);
    }

    if (name === "location_id") {
      setRequest({
        ...request,
        location_id: "",
        vendor_id: "",
        audit_type: "",
      });
      // getRegionsList("", "");
      // getGroupsList("", getValue(request, `region_id`, ""), "");
      getLocationsList(
        "",
        getValue(request, `region_id`, ""),
        getValue(request, `group_id`, ""),
        getValue(request, `state_id`, ""),
        getValue(request, `city_id`, ""),
        ""
      );
      setvendorsList([]);
    }
    if (name === "vendor_id") {
      setRequest({
        ...request,
        vendor_id: "",
        audit_type: "",
      });
      // getRegionsList("", "");
      // getGroupsList("", getValue(request, `region_id`, ""), "");
      // getLocationsList(
      //   "",
      //   getValue(request, `region_id`, ""),
      //   getValue(request, `group_id`, ""),
      //   ""
      // );
      getVendorList(
        "",
        getValue(request, `region_id`, ""),
        getValue(request, `group_id`, ""),
        getValue(request, `state_id`, ""),
        getValue(request, `city_id`, ""),
        getValue(request, `location_id`, ""),
        ""
      );
    }
  };

  const handleSelectFilter = (id: any, name: string) => {
    if (name === "region_id") {
      getGroupsList("", id, "");
      setRequest({
        ...request,
        group_id: "",
        state_id: "",
        city_id: "",
        location_id: "",
        vendor_id: "",
        audit_type: "",
      });
      setGroupsList([]);
      setStateList([]);
      setCityList([]);
      setlocationsList([]);
      setvendorsList([]);
    }
    if (name === "group_id") {
      getStatesList("", getValue(request, `region_id`, ""), id, "");
      setRequest({
        ...request,
        state_id: "",
        city_id: "",
        location_id: "",
        vendor_id: "",
        audit_type: "",
      });
      setStateList([]);
      setCityList([]);
      setlocationsList([]);
      setvendorsList([]);
    }

    if (name === "state_id") {
      getCitiesList(
        "",
        getValue(request, `region_id`, ""),
        getValue(request, `group_id`, ""),
        id,
        ""
      );
      setRequest({
        ...request,
        city_id: "",
        location_id: "",
        vendor_id: "",
        audit_type: "",
      });
      setCityList([]);
      setlocationsList([]);
      setvendorsList([]);
    }

    if (name === "city_id") {
      getLocationsList(
        "",
        getValue(request, `region_id`, ""),
        getValue(request, `group_id`, ""),
        getValue(request, `state_id`, ""),
        id,
        ""
      );
      setRequest({
        ...request,
        location_id: "",
        vendor_id: "",
        audit_type: "",
      });
      setlocationsList([]);
      setvendorsList([]);
    }

    if (name === "location_id") {
      getVendorList(
        "",
        getValue(request, `region_id`, ""),
        getValue(request, `group_id`, ""),
        getValue(request, `state_id`, ""),
        getValue(request, `city_id`, ""),
        id,
        ""
      );
      setRequest({
        ...request,
        vendor_id: "",
        audit_type: "",
      });
      setvendorsList([]);
    }

    setRequest({
      ...request,
      [name]: id,
    });
  };

  // const handleSubmitSmartFilter = () => {
  //   const urlSearchParams = new URLSearchParams(window.location.search);
  //   const params = Object.fromEntries(urlSearchParams.entries());
  //   let payload: any = {
  //     ...params,
  //     region_id: getValue(request, `region_id`, ""),
  //     group_id: getValue(request, `group_id`, ""),
  //     location_id: getValue(request, `location_id`, ""),
  //     vendor_id: getValue(request, `vendor_id`, ""),
  //   };
  //   let queryRequest = QueryRequestHelper(payload);
  //   navigate(`${window.location.pathname}?${queryRequest}`);
  //   // handleFilter();
  // };

  // let region_ID =
  //   getValue(regionList, `length`, 0) > 0 &&
  //   regionList.filter(
  //     (item: object) =>
  //       getValue(item, `id`, "") == getValue(request, `region_id`, "")
  //   );

  // let group_ID =
  //   getValue(groupsList, `length`, 0) > 0 &&
  //   groupsList.filter(
  //     (item: object) =>
  //       getValue(item, `id`, "") == getValue(request, `group_id`, "")
  //   );

  // let location_ID =
  //   getValue(locationsList, `length`, 0) > 0 &&
  //   locationsList.filter(
  //     (item: object) =>
  //       getValue(item, `id`, "") == getValue(request, `location_id`, "")
  //   );

  // let vendor_ID =
  //   getValue(vendorsList, `length`, 0) > 0 &&
  //   vendorsList.filter(
  //     (item: object) =>
  //       getValue(item, `id`, "") == getValue(request, `vendor_id`, "")
  //   );

  const handleSubmitSmartFilter = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      country_id: getValue(request, `country_id`, ""),
      state_id: getValue(request, `state_id`, ""),
      city_id: getValue(request, `city_id`, ""),
      region_id: getValue(request, `region_id`, ""),
      group_id: getValue(request, `group_id`, ""),
      location_id: getValue(request, `location_id`, ""),
      vendor_id: getValue(request, `vendor_id`, ""),
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    handleFilter();
  };

  let state_ID =
    getValue(stateList, `length`, 0) > 0 &&
    stateList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `state_id`, "")
    );

  let city_ID =
    getValue(cityList, `length`, 0) > 0 &&
    cityList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `city_id`, "")
    );
  let region_ID =
    getValue(regionList, `length`, 0) > 0 &&
    regionList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `region_id`, "")
    );

  let group_ID =
    getValue(groupsList, `length`, 0) > 0 &&
    groupsList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `group_id`, "")
    );

  let location_ID =
    getValue(locationsList, `length`, 0) > 0 &&
    locationsList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `location_id`, "")
    );

  let vendor_ID =
    getValue(vendorsList, `length`, 0) > 0 &&
    vendorsList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `vendor_id`, "")
    );

  // console.log(getValue(props, `tabPermissionList`, []), "tabPermissionList");
  // console.log(getValue(props, `subTabPermissionList`, []), "subTabPermissionList")

  const handleNavigateVCMaster = (
    audit_status: string,
    event_text: string,
    category_of_law_text: string
  ) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    let selectedMonth = params.date
      ? params.date.split("-")[1]
      : date
      ? moment(date).format("MM")
      : moment(dates).format("MM");
    let selectedYear = params.date
      ? params.date.split("-")[0]
      : date
      ? moment(date).format("YYYY")
      : moment(dates).format("YYYY");

    let payload: any = {
      date: convertDate(date),
      region_id: getValue(params, `region_id`, ""),
      group_id: getValue(params, `group_id`, ""),
      state_id: getValue(params, `state_id`, ""),
      city_id: getValue(params, `city_id`, ""),
      location_id: params.location_id,
      vendor_id: params.vendor_id,
      audit_status: audit_status,
      event_text: event_text,
      category_of_law_text: category_of_law_text,

      is_redirect: true,
    };

    let queryRequest = QueryRequestHelper(payload);
    navigate(`/repository/vendor-compliance/master?${queryRequest}`);
  };

  const [isOpen, setIsOpen] = useState(false);
  // const handleModal = (type:any) => {
  //   setIsOpen(!isOpen);
  //   getReleaseCycleDetailsData(type);
  // };
  const handleModal = (type: any) => {
    setIsOpen(!isOpen);
  
    // Update query params with the selected type
    const url = new URL(window.location.href);
    url.searchParams.set("type", type);
    window.history.replaceState(null, "", url.toString());
  
    // Fetch data with the selected type
    getReleaseCycleDetailsData(type);
  };
  
  const handleModalClose = () => {
    const url = new URL(window.location.href);
    url.searchParams.delete("type");
    url.searchParams.delete("page_no");
    window.history.replaceState(null, "", url.toString());
    setPage_no(1);
    setIsOpen(!isOpen);
  }

  const [selectedId, setSelectedId] = useState("");
  const rowClick = (obj: object) => {};

  const rowClickAll = (obj: object) => {
    // const urlSearchParams = new URLSearchParams(window.location.search);
    // const params = Object.fromEntries(urlSearchParams.entries());
    // let dates = date ? date : new Date();
    // let selectedMonth = params.date
    //   ? params.date.split("-")[1]
    //   : date
    //   ? moment(date).format("MM")
    //   : moment(dates).format("MM");
    // let selectedYear = params.date
    //   ? params.date.split("-")[0]
    //   : date
    //   ? moment(date).format("YYYY")
    //   : moment(dates).format("YYYY");

    // let payload: any = {
    //   date: convertDate(date),
    //   region_id: getValue(params, `region_id`, ""),
    //   group_id: getValue(params, `group_id`, ""),
    //   state_id: getValue(params, `state_id`, ""),
    //   city_id: getValue(params, `city_id`, ""),
    //   location_id: getValue(obj, `original.site_id`, ""),
    //   vendor_id: getValue(obj, `original.vendor_id`, ""),
    //   is_redirect: true,
    // };

    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    let selectedMonth = params.date
      ? params.date.split("-")[1]
      : date
      ? moment(date).format("MM")
      : moment(dates).format("MM");
    let selectedYear = params.date
      ? params.date.split("-")[0]
      : date
      ? moment(date).format("YYYY")
      : moment(dates).format("YYYY");

    let payload: any = {
      month: params.date
        ? params.date.split("-")[1]
        : date
        ? moment(date).format("MM")
        : moment(dates).format("MM"),
      year: params.date
        ? params.date.split("-")[0]
        : date
        ? moment(date).format("YYYY")
        : moment(dates).format("YYYY"),
      date: convertDate(date),
      region_id: getValue(params, `region_id`, ""),
      group_id: getValue(params, `group_id`, ""),
      state_id: getValue(params, `state_id`, ""),
      city_id: getValue(params, `city_id`, ""),
      location_id: getValue(obj, `original.site_id`, ""),
      vendor_id: getValue(obj, `original.vendor_id`, ""),
      is_redirect: true,
    };

    let queryRequest = QueryRequestHelper(payload);
    navigate(`/repository/vendor-compliance/master?${queryRequest}`);
  };

  const rowClickSubmit = (obj: object, is_submitted:number) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    let selectedMonth = params.date
      ? params.date.split("-")[1]
      : date
      ? moment(date).format("MM")
      : moment(dates).format("MM");
    let selectedYear = params.date
      ? params.date.split("-")[0]
      : date
      ? moment(date).format("YYYY")
      : moment(dates).format("YYYY");

    let payload: any = {
      month: params.date
        ? params.date.split("-")[1]
        : date
        ? moment(date).format("MM")
        : moment(dates).format("MM"),
      year: params.date
        ? params.date.split("-")[0]
        : date
        ? moment(date).format("YYYY")
        : moment(dates).format("YYYY"),
      date: convertDate(date),
      region_id: getValue(params, `region_id`, ""),
      group_id: getValue(params, `group_id`, ""),
      state_id: getValue(params, `state_id`, ""),
      city_id: getValue(params, `city_id`, ""),
      location_id: getValue(obj, `original.site_id`, ""),
      vendor_id: getValue(obj, `original.vendor_id`, ""),
      is_submitted: is_submitted, // Ensure is_submitted is included here
      is_redirect: true,
    };

    let queryRequest = QueryRequestHelper(payload);
    navigate(`/repository/vendor-compliance/master?${queryRequest}`);
  };

  const getTrProps = (rowInfo: any) => {
    if (getValue(rowInfo, `id`, "")) {
      return {
        style: {
          //   background:  'red',
          //   color: 'black'
        },
      };
    }
    return {};
  };

  const [selectedIDs, setSelectedIDs] = useState<any>([]);
  const getTableState = (value: object) => {
      let selectedIndexList = Object.keys(
          getValue(value, `selectedRowIds`, {})
      ).map((item) => parseInt(item));
      let selectedIds =
          releaseDateCycleDataList.length > 0
              ? releaseDateCycleDataList.filter((_item: object, index: number) =>
                      selectedIndexList.includes(index)
                )
              : [];
      if (selectedIds.length > 0) {
          setSelectedIDs(
              selectedIds.map((item: object) => getValue(item, `id`, ""))
          );
      } else {
          setSelectedIDs([]);
      }
  };


  const columns = React.useMemo(
    () => [
      {
        Header: "Vendor Name",
        accessor: "vendor_name",
        width: 200,
      },
      {
        Header: "Account Name",
        accessor: "group_name",
        width: 150,
      },
      {
        Header: "Site Name",
        accessor: "site_name",
        width: 150,
      },

      {
        Header: "Submitted Task",
        accessor: "fully_completed_tasks",
        width: 150,
        Cell: ({ row }: any) => {
          const handleRowClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
            event.preventDefault();
            event.stopPropagation();
            rowClickSubmit(row, 1);
          };
      
          return (
            <div onClick={handleRowClick} className="text-primary">
              {getValue(row, "original.fully_completed_tasks", "")}
            </div>
          );
        },
      },

      {
        Header: "Un-Submitted Task",
        accessor: "not_completed_tasks",
        width: 150,
        Cell: ({ row }: any) => {
          const handleRowClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
            event.preventDefault();
            event.stopPropagation();
            rowClickSubmit(row, 2);
          };
      
          return (
            <div onClick={handleRowClick} className="text-primary">
              {getValue(row, "original.not_completed_tasks", "")}
            </div>
          );
        },
      },
    //   {
    //     Header: "Partially Completed Task",
    //     accessor: "partially_completed_tasks",
    //   },
      {
        Header: "Total Task",
        accessor: "total_tasks",
        width: 100,
        Cell: ({ row }: any) => {
          const handleRowClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
            event.preventDefault();
            event.stopPropagation();
            rowClickAll(row);
          };
      
          return (
            <div onClick={handleRowClick} className="text-primary">
              {getValue(row, "original.total_tasks", "")}
            </div>
          );
        },
      },

      {
        Header: "Score",
        accessor: "score_count",
        width: 150,
      },

      {
        Header: "Headcount",
        accessor: "head_count",
        width: 150,
      },
      
    ],
    []
  );
const handleDownloadVendorAuditReport = async () => {
  const dates = params.date ? new Date(params.date) : new Date();

  const payload = cleanPayload({
    report_type: "VENDOR_AUDIT_OVERVIEW",
    report_name: `vendor audit overview-${moment(dates).format("MMM-YYYY")}`,
    month: params.date
      ? Number(params.date.split("-")[1])
      : Number(moment(dates).format("MM")),
    year: params.date
      ? Number(params.date.split("-")[0])
      : Number(moment(dates).format("YYYY")),
  });

  setIsLoading(true);

  try {
    const resp = await vendorAuditOverview(payload);

    if (resp) {
      toast.success(
        getValue(resp, "message", "Export triggered successfully")
      );

      navigate(`/self-compliance-logs/VENDOR_AUDIT_OVERVIEW`);
    }
  } catch (error) {
    console.error("Download failed:", error);
    toast.error("Failed to download report");
  } finally {
    setIsLoading(false);
  }
};

 return (
    <DashboardLayout
      permissions={getValue(props, `tabPermissionList`, [])}
      subTabPermissionList={getValue(props, `subTabPermissionList`, [])}
    >
      {isLoading ? (
        <Loader />
      ) : (
        <>
          {!isLoading &&
          !getValue(props, `subTabPermissionList`, []).includes(
            "dashboard_vendor_audit"
          ) ? (
            <NoAccessPage />
          ) 
      // : isLoading || !props.permissionAPITriggered ? (
      //   <Loader />
      // ) 
      : (
        <>
          {/* <div className="dashboard-wrapper__header">
              <h4 className="dashbaord-wrapper__header-title">PE Compliance</h4>
            </div> */}

          <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <div className="header-parent-icon-holder">
                <DashboardSvgComponent />
              </div>

              <div className="title-wrapper">
                <h6 className="dashbaord-wrapper__header-parent-title">
                  Dashboard
                </h6>
                <h4 className="dashbaord-wrapper__header-title">
                  Vendor Compliance
                </h4>
              </div>
            </div>

            <div className="d-flex">
              <RightMenuHeaders
                // smartFilter={true}
                // handleFilter={handleFilter}
                // lineSeperator={true}
                // selectedFilterCount={countKeysWithValues(params)}
                // date range
                // dateRange={true}
                // from_date={from_date}
                // to_date={to_date}
                // handleDate={handleDate}
                // handleSubmitDate={handleSubmitDate}
                monthYear={true}
                value={date}
                onChange={setDate}
                handleSubmitDate={handleSubmitDate}
                lineSeperator={true}
                 downloadLoading={isLoading}
                  downloadSelfComplianceReport={true}
              handleDownloadSelfComplianceReport={handleDownloadVendorAuditReport}
              // viewDownloadedSelfComplianceReports={true}
              />
              <div className="refresh-button-wrapper sub-header-icons-holder ms-0">
                <button
                  onClick={() => handleRefresh()}
                  className={`icons-btn`}
                  data-tip
                  data-for="checkTest"
                  disabled={refreshLoading}
                >
                  <RefreshSvgComponent size={24} color={"#5F6368"}
                  classname={refreshLoading ? "spin-icon" : ""} />
                  <ReactTooltip id="checkTest" effect="solid" place="bottom">
                    Refresh
                  </ReactTooltip>
                </button>
              </div>
            </div>
          </div>

          <div
            className={`main-page-layout-wrapper main-page-layout-wrapper-dashboard`}
          >
            {noData ? (
              <VCMasterNotfound />
            ) : (
              <div className="overview-wrapper pt-1">
                {/* d-flex align-items-center justify-content-between */}
                <div className="filter-section-wrap module-filter-wrapper">
                  <div className="width-20">
                    <div className="filter-form-wrappper__location-input module_filter_fields_wrapper">
                      <label htmlFor="country_id" className="floating-label">
                        Region
                      </label>
                      <SearchableDropdownSelect
                        placeholder={`Select Region`}
                        options={regionList}
                        searchLoading={regionLoading}
                        handleChange={(val: any) =>
                          val
                            ? getRegionsList(val, "")
                            : handleRemoveFilter("region_id")
                        }
                        handleClick={(e: any) =>
                          handleSelectFilter(getValue(e, `id`, ""), "region_id")
                        }
                        // value={region_ID}
                        value={
                          Array.isArray(region_ID) && region_ID.length > 0
                            ? region_ID[0]
                            : ""
                        }
                        label="label"
                        id="id"
                        name={"region_id"}
                      />
                    </div>
                  </div>

                  <div className="width-20">
                    <div className="filter-form-wrappper__location-input module_filter_fields_wrapper">
                      <label htmlFor="country_id" className="floating-label">
                        Account
                      </label>
                      <SearchableDropdownSelect
                        placeholder={`Select Account`}
                        options={groupsList}
                        searchLoading={groupLoading}
                        handleChange={(val: any) =>
                          val
                            ? getGroupsList(
                                val,
                                getValue(request, `group_id`, ""),
                                ""
                              )
                            : handleRemoveFilter("group_id")
                        }
                        handleClick={(e: any) =>
                          handleSelectFilter(getValue(e, `id`, ""), "group_id")
                        }
                        // value={group_ID}
                        value={
                          Array.isArray(group_ID) && group_ID.length > 0
                            ? group_ID[0]
                            : ""
                        }
                        label="label"
                        id="id"
                        name={"group_id"}
                      />
                    </div>
                  </div>

                  <div className="width-20">
                    <div className="filter-form-wrappper__location-input module_filter_fields_wrapper">
                      <label htmlFor="country_id" className="floating-label">
                        State
                      </label>
                      <SearchableDropdownSelect
                        placeholder={`Choose State`}
                        options={stateList}
                        searchLoading={stateLoading}
                        handleChange={(val: any) =>
                          val
                            ? getStatesList(
                                val,
                                getValue(request, `region_id`, ""),
                                getValue(request, `group_id`, ""),
                                // getValue(props, `request.state_id`, ""),
                                ""
                              )
                            : handleRemoveFilter("state_id")
                        }
                        handleClick={(e: any) =>
                          handleSelectFilter(getValue(e, `id`, ""), "state_id")
                        }
                        value={
                          Array.isArray(state_ID) && state_ID.length > 0
                            ? state_ID[0]
                            : ""
                        }
                        label="label"
                        id="id"
                        name={"state_id"}
                      />
                    </div>
                  </div>

                  <div className="width-20">
                    <div className="filter-form-wrappper__location-input module_filter_fields_wrapper">
                      <label htmlFor="country_id" className="floating-label">
                        City
                      </label>
                      <SearchableDropdownSelect
                        placeholder={`Choose City`}
                        options={cityList}
                        searchLoading={cityLoading}
                        handleChange={(val: any) =>
                          val
                            ? getCitiesList(
                                val,
                                getValue(request, `region_id`, ""),
                                getValue(request, `group_id`, ""),
                                getValue(request, `state_id`, ""),
                                // getValue(props, `request.city_id`, ""),
                                ""
                              )
                            : handleRemoveFilter("city_id")
                        }
                        handleClick={(e: any) =>
                          handleSelectFilter(getValue(e, `id`, ""), "city_id")
                        }
                        // value={getValue(props, `city_ID[${0}]`, "")}
                        value={
                          Array.isArray(city_ID) && city_ID.length > 0
                            ? city_ID[0]
                            : ""
                        }
                        label="label"
                        id="id"
                        name={"city_id"}
                      />
                    </div>
                  </div>

                  <div className="width-20">
                    <div className="filter-form-wrappper__location-input module_filter_fields_wrapper">
                      <label htmlFor="country_id" className="floating-label">
                        Site
                      </label>
                      <SearchableDropdownSelect
                        placeholder={`Select Site`}
                        options={locationsList}
                        searchLoading={locationLoading}
                        handleChange={(val: any) =>
                          val
                            ? getLocationsList(
                                val,
                                getValue(request, `region_id`, ""),
                                getValue(request, `group_id`, ""),
                                getValue(request, `state_id`, ""),
                                getValue(request, `city_id`, ""),
                                ""
                              )
                            : handleRemoveFilter("location_id")
                        }
                        handleClick={(e: any) =>
                          handleSelectFilter(
                            getValue(e, `id`, ""),
                            "location_id"
                          )
                        }
                        // value={location_ID}
                        value={
                          Array.isArray(location_ID) && location_ID.length > 0
                            ? location_ID[0]
                            : ""
                        }
                        x
                        label="label"
                        id="id"
                        name={"location_id"}
                        // removeClose
                      />
                    </div>
                  </div>

                  <div className="width-20">
                    <div className="filter-form-wrappper__location-input module_filter_fields_wrapper">
                      <label htmlFor="country_id" className="floating-label">
                        Vendor
                      </label>
                      <SearchableDropdownSelect
                        placeholder={`Select Vendor`}
                        options={vendorsList}
                        searchLoading={vendorLoading}
                        handleChange={(val: any) =>
                          val
                            ? getVendorList(
                                val,
                                getValue(request, `region_id`, ""),
                                getValue(request, `group_id`, ""),
                                getValue(request, `state_id`, ""),
                                getValue(request, `city_id`, ""),
                                getValue(request, `location_id`, ""),
                                ""
                              )
                            : handleRemoveFilter("vendor_id")
                        }
                        handleClick={(e: any) =>
                          handleSelectFilter(getValue(e, `id`, ""), "vendor_id")
                        }
                        value={
                          Array.isArray(vendor_ID) && vendor_ID.length > 0
                            ? vendor_ID[0]
                            : ""
                        }
                        label="label"
                        id="id"
                        name={"vendor_id"}
                        // removeClose
                        disabled={props.disableVendor}
                      />
                    </div>
                  </div>

                  <div className="width-18">
                    <div className="filter-form-wrappper__cta-wrapper">
                      <button
                        className="filter-form-wrappper__cta-btn filter-form-wrappper__cta-btn--search btn btn-primary"
                        onClick={handleSubmitSmartFilter}
                      >
                        Search
                      </button>
                      <button
                        className="filter-form-wrappper__cta-btn filter-form-wrappper__cta-btn--reset btn"
                        onClick={reset}
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                </div>

                <hr />
                {Object.keys(releaseDateCycleData).length > 0 && (
                  <div className="d-flex">
                    <div className="stats-card-wrap w-100">
                      <div className="card p-2 w-100 mb-3">
                        <div className="mb-2 text-left">Audit Stats</div>
                        <div className="d-flex align-items-center justify-content-between">
                          {Object.entries(releaseDateCycleData).map(([key, value]) => (
                            <div
                              key={key}
                              className="card card-release-cycle"
                              style={{
                                width: "calc(20% - 10px)",
                                marginRight: "10px",
                                padding: "5px"
                              }}
                              // onClick={() => handleModal(key.replace(/_count/i, ""))}
                              onClick={() => handleModal(key.replace(/_count/i, ""))}
                            >
                              <div className="fs-13">
                                {formatText(
                                  key.replace(/count/i, "").replace(/location/i, "Sites")
                                )}
                              </div>
                              <div>
                                <b>{String(value)}</b>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                )}


                <div className="d-flex gap-3 mb-3">
                  <div
                    className="graph-wrapper bg-white card w-100"
                    style={{ height: "300px" }}
                  >
                    <Line
                      data={chartData}
                      options={{
                        ...options,
                        maintainAspectRatio: false, // This ensures the height is respected
                      }}
                      style={{ height: "300px" }}
                    />
                  </div>
                </div>

                <div className="d-flex gap-3 mb-3">
                  <div className="graph-wrapper bg-white card w-50">
                    <Bar
                      data={dataBarChart}
                      options={{
                        ...optionsBarChart,
                        onClick: function (evt, element) {
                          if (element.length > 0) {
                            let datasetIndex = element[0].datasetIndex;
                            let ind = element[0].index;
                            let graphName =
                              dataBarChart.datasets[datasetIndex].label;
                            handleNavigateVCMaster(
                              "NON_COMPLIED",
                              graphName,
                              ""
                            );
                          }
                        },
                      }}
                    />
                  </div>

                  <div className="graph-wrapper  w-50">
                    <div
                      className="navtabs-pillable"
                      style={{
                        backgroundColor: "#ffffff",
                        border: "1px solid #dadce0",
                        borderRadius: ".25rem",
                      }}
                    >
                      <div className="d-flex align-items-center justify-content-between">
                        <div>
                          <span
                            className="ms-2"
                            style={{
                              color: "#666666",
                              fontSize: "14px",
                              fontWeight: "500",
                            }}
                          >
                            Overall audit task breakup
                          </span>
                        </div>
                        <Nav
                          tabs
                          className="justify-content-end align-items-center pt-2 pe-2"
                        >
                          <NavItem>
                            <NavLink
                              className={activeTab === "1" ? "active" : ""}
                              onClick={() => toggleTab("1")}
                            >
                              Percentage Graph
                            </NavLink>
                          </NavItem>

                          <NavItem>
                            <NavLink
                              className={activeTab === "2" ? "active" : ""}
                              onClick={() => toggleTab("2")}
                            >
                              Number Graph
                            </NavLink>
                          </NavItem>
                        </Nav>
                      </div>

                      <TabContent
                        activeTab={activeTab}
                        className="mb-0"
                        style={{ marginTop: ".5rem" }}
                      >
                        <TabPane tabId="1" className="">
                          <div style={{ height: "300px" }}>
                            <div
                              style={{
                                height: "300px",
                                position: "relative",
                                borderTop: "1px solid #dadce0",
                              }}
                              // className="vendor-graph"
                            >
                              <ResponsivePie
                                data={donutData}
                                margin={{
                                  top: 40,
                                  right: 80,
                                  bottom: 40,
                                  left: 40,
                                }}
                                colors={colorsChartNew}
                                innerRadius={0.5}
                                padAngle={0}
                                cornerRadius={0}
                                activeOuterRadiusOffset={10}
                                borderWidth={1}
                                borderColor={{
                                  from: "color",
                                  modifiers: [["darker", 0.2]],
                                }}
                                arcLinkLabelsDiagonalLength={16}
                                arcLinkLabelsTextColor="#333333"
                                arcLinkLabelsThickness={2}
                                arcLinkLabelsColor={{ from: "color" }}
                                arcLabelsSkipAngle={2}
                                arcLabelsTextColor={{
                                  from: "color",
                                  modifiers: [["darker", 2]],
                                }}
                                arcLabel={(d) => `${d.formattedValue}%`}
                                arcLinkLabel={(e) => {
                                  const displayValue = String(e.id).replace(
                                    " Percentage",
                                    ""
                                  ); // Convert id to string and remove " Percentage"
                                  return displayValue; // Show the category name only
                                }}
                                arcLinkLabelsOffset={1}
                                arcLinkLabelsStraightLength={30}
                                arcLinkLabelsTextOffset={6}
                                arcLinkLabelsSkipAngle={3}
                                onClick={(data: any) => {
                                  const displayValue = String(data.label)
                                    .replace(" Percentage", "") // Remove " Percentage"
                                    .split(" ") // Split the string into words
                                    .map((word) => word.toUpperCase()) // Convert each word to uppercase
                                    .join("_"); // Join the words with an underscore
                                  handleNavigateVCMaster(displayValue, "", "");
                                }}
                                tooltip={({ datum: { id, value, color } }) => (
                                  <div
                                    style={{
                                      padding: "5px 10px",
                                      color: "#000",
                                      background: "#fff",
                                      border: `2px solid ${color}`,
                                      borderRadius: "3px",
                                    }}
                                  >
                                    <span>
                                      {String(id).replace(" Percentage", "")}{" "}
                                    </span>
                                    : {value}% {/* Convert id to string */}
                                  </div>
                                )}
                              />
                            </div>
                          </div>
                        </TabPane>

                        <TabPane tabId="2" className="">
                          <div style={{ height: "300px" }}>
                            <div
                              style={{
                                height: "300px",
                                position: "relative",
                                borderTop: "1px solid #dadce0",
                              }}
                              // className="vendor-graph"
                            >
                              <ResponsivePie
                                data={numberDonutData}
                                margin={{
                                  top: 40,
                                  right: 80,
                                  bottom: 40,
                                  left: 40,
                                }}
                                colors={colorsChartNew}
                                innerRadius={0.5}
                                padAngle={0}
                                cornerRadius={0}
                                activeOuterRadiusOffset={10}
                                borderWidth={1}
                                borderColor={{
                                  from: "color",
                                  modifiers: [["darker", 0.2]],
                                }}
                                arcLinkLabelsDiagonalLength={16}
                                arcLinkLabelsTextColor="#333333"
                                arcLinkLabelsThickness={2}
                                arcLinkLabelsColor={{ from: "color" }}
                                arcLabelsSkipAngle={2}
                                arcLabelsTextColor={{
                                  from: "color",
                                  modifiers: [["darker", 2]],
                                }}
                                arcLabel={(d) => `${d.formattedValue}`}
                                arcLinkLabel={(e) => {
                                  const displayValue = String(e.id); // Convert id to string and remove " Percentage"
                                  return displayValue; // Show the category name only
                                }}
                                arcLinkLabelsOffset={1}
                                arcLinkLabelsStraightLength={30}
                                arcLinkLabelsTextOffset={6}
                                arcLinkLabelsSkipAngle={3}
                                onClick={(data: any) => {
                                  const displayValue = String(data.label)
                                    .replace(" Percentage", "") // Remove " Percentage"
                                    .split(" ") // Split the string into words
                                    .map((word) => word.toUpperCase()) // Convert each word to uppercase
                                    .join("_"); // Join the words with an underscore
                                  handleNavigateVCMaster(displayValue, "", "");
                                }}
                                tooltip={({ datum: { id, value, color } }) => (
                                  <div
                                    style={{
                                      padding: "5px 10px",
                                      color: "#000",
                                      background: "#fff",
                                      border: `2px solid ${color}`,
                                      borderRadius: "3px",
                                    }}
                                  >
                                    <span>
                                      {String(id).replace(" Percentage", "")}
                                    </span>
                                    : {value} {/* Convert id to string */}
                                  </div>
                                )}
                              />
                            </div>
                          </div>
                        </TabPane>
                      </TabContent>
                    </div>
                  </div>
                </div>

                <div className="d-flex gap-3">
                  <div className="graph-wrapper bg-white card w-50">
                    <Bar
                      data={dataBarChartNC}
                      // options={optionsBarChartNC}
                      options={{
                        ...optionsBarChartNC,
                        onClick: function (evt, element) {
                          if (element.length > 0) {
                            let datasetIndex = element[0].datasetIndex;
                            let ind = element[0].index;
                            let graphName =
                              dataBarChartNC.datasets[datasetIndex].label;
                            let modifiedGraphName = graphName
                              .replace("Category", "")
                              .trim();
                            handleNavigateVCMaster(
                              "NON_COMPLIED",
                              "",
                              modifiedGraphName
                            );
                          }
                        },
                      }}
                    />
                  </div>

                  <div className="graph-wrapper bg-white card w-50">
                    <Bar data={dataBarChartAC} options={optionsBarChartAC} />
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* <div className="text-right">
              <img src="/images/profile-illustration.svg" className="img-fluid" />
            </div> */}
        </>
      )}
        </>
      )}

      <Modal isOpen={isOpen} toggle={handleModal} size="xl">
        <ModalHeader toggle={handleModalClose}>Audit Stats Details</ModalHeader>
        <ModalBody className="w-100 audit-stats-details">
            <div>
            {releaseDateCycleDataList.length > 0 ? (
                <>
                <ScrollableDataTable
                    columns={columns}
                    data={releaseDateCycleDataList}
                    getTableState={getTableState}
                    rowClick={rowClick}
                    check={true}
                    selectedIDs={selectedIDs}
                    getTrProps={getTrProps}
                    checkboxlogo
                />
                <FooterWrapper
                    list={releaseDateCycleDataList}
                    totalCount={totalCount}
                    limit={limit}
                    page_no={page_no}
                    handleChangePagination={handleChangePagination}
                    handleChangeLimit={handleChangeLimit}
                    />
                </>
            ) : (
                <>
                <Notfound />
                </>
            )}
            </div>
        </ModalBody>
      </Modal>
    </DashboardLayout>
  );
}
